import React from 'react';
import styled from 'styled-components';
import StoreButtons from './StoreButtons';

const Ribbon = styled.section`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100vw;
	padding: 30px 10vw;
	padding: 30px var(--side-margin);

	h2 {
		text-align: center;
		color: #FF9C46;
		margin-bottom: 20px;

		@media screen and (max-width: ${props => props.theme.mobileBreakPoint}) {
			padding: 0px 15px;
			font-size: var(--fs-big);
		}
	}
`;

const StoreAppsRibbon = () => {
	return (
		<Ribbon>
			<h2>Start shopping with Blidz now</h2>
			<StoreButtons />
		</Ribbon>
	);
};

export default StoreAppsRibbon;



// WEBPACK FOOTER //
// ./src/components/StoreAppsRibbon.js